/**
 * Closing conversion band — sits at the very bottom of the public landing page,
 * before the legal footer (still to be added). Repeats the primary CTA copy
 * introduced in the header + hero, so scroll-through visitors don't have to
 * jump back up to convert.
 */
export default function LandingClosingCTA() {
  return (
    <section
      className="relative bg-charcoal text-bone py-20 sm:py-28 lg:py-32 overflow-hidden"
      data-testid="landing-closing-cta"
      aria-label="Gain access to the research catalog"
    >
      {/* Ambient oxblood radial wash */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden
        style={{
          background:
            "radial-gradient(900px 400px at 30% 40%, rgba(74,14,23,0.35), transparent 65%), radial-gradient(700px 350px at 90% 100%, rgba(140,123,102,0.15), transparent 60%)",
        }}
      />
      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        aria-hidden
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(249,248,246,1) 1px, transparent 0)",
          backgroundSize: "3px 3px",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
        <p className="text-[13px] uppercase tracking-[0.32em] text-bone/85 font-mono">
          Ready when you are
        </p>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
          The catalog is <span className="italic text-bone/70">members-only.</span>
        </h2>
        <p className="mt-6 max-w-[54ch] mx-auto text-base sm:text-lg text-bone/70 leading-relaxed">
          Request access to view every kit, every vial size, and every wholesale
          price — approval is almost instantaneous.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="#request-access"
            className="group inline-flex items-center gap-3 rounded-full bg-bone text-charcoal pl-6 pr-4 py-4 text-xs uppercase tracking-[0.22em] hover:bg-oxblood hover:text-bone transition-colors"
            data-testid="landing-closing-primary-cta"
          >
            Gain access to the research catalog
            <span
              className="grid place-items-center w-7 h-7 rounded-full bg-charcoal/10 group-hover:bg-bone/15 transition-colors"
              aria-hidden
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </a>

          <a
            href="/enter"
            className="text-[13px] uppercase tracking-[0.24em] text-bone/80 border-b border-bone/40 hover:border-bone hover:text-bone pb-1 transition-colors"
            data-testid="landing-closing-secondary-cta"
          >
            Already a researcher? Sign in
          </a>
        </div>
      </div>
    </section>
  );
}
